export const number = (value: string | number | null): string => {
  const parsedValue = typeof value === "string" ? parseInt(value, 10) : value

  if (parsedValue === undefined || parsedValue === null || Number.isNaN(parsedValue)) {
    return ""
  }

  return parsedValue.toString()
}
